const VERSIONS = {
  BROGRAMMERS: {
    brand: 'Brogrammers',
    email: 'brogrammers@gmail.com',
    url: 'https://brogrammers.in/favicon_bro.ico',
  },
  EDUNEXORA: {
    brand: 'Edunexora',
    email: 'admin@edunexora.com',
    url: 'https://vinit-jains-bucket.s3.ap-south-1.amazonaws.com/android-chrome-192x192.png',
  },
  ZENSHKOOL: {
    brand: 'Zenshkool',
    email: 'zenshkoolaigmail.com',
    url: 'https://vinit-jains-bucket.s3.ap-south-1.amazonaws.com/image+(1).png',
  },
};

module.exports = VERSIONS;
